import { z } from "zod";

export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID!;

export const passwordSchema = z
  .string()
  .trim()
  .min(1, "Password is required")
  .min(8, "Password must be at least 8 characters long")
  .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
  .regex(/[a-z]/, "Password must contain at least one lowercase letter")
  .regex(/[0-9]/, "Password must contain at least one digit")
  .regex(
    /[!@#$%^&*(),.?":{}|<>]/,
    "Password must contain at least one special character",
  );

export const emailSchema = z
  .string()
  .trim()
  .min(1, "Email address is required")
  .email("Please enter a valid email address");

export const fullNameSchema = z
  .string()
  .trim()
  .min(1, "Full name is required")
  .min(2, "Full name must be at least 2 characters long")
  .max(80, "Full name must be at most 80 characters long")
  .regex(
    /^[\p{L}][\p{L}'.-]*(?: [\p{L}][\p{L}'.-]*)*$/u,
    "Full name contains invalid characters",
  );

export const signUpValidationSchema = z.object({
  fullName: fullNameSchema,
  email: emailSchema,
  password: passwordSchema,
});

export const resetPasswordValidationSchema = z.object({
  email: emailSchema,
});

export const signInValidationSchema = z.object({
  email: emailSchema,
  password: z.string().trim().min(1, "Password is required"),
});

export const setNewPasswordValidationSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords must match",
    path: ["confirmPassword"],
  });

export const EMAIL_ALREADY_EXISTS_ERR = "Email address already exists.";
export const USER_NOT_EXIST_ERR = "User does not exist.";
export const EMAIL_NOT_VERIFIED_ERR = "Email address is not verified.";
export const SET_PASSWORD_TOKEN_EXPIRED_ERR = "Token expired.";

// Generic password for Google login required by the Backend
export const GOOGLE_GENERIC_PASSWORD = "__Google_Auth_1__";
